import axiosClient from "api/axios_client.js";

const apiRoleModuleMapping = {
  getByRole: (roleId) => axiosClient.get(`/user-role-module/role-module-mapping/get-by-role/${roleId}`),
  save: (roleId, modules) => axiosClient.put(`/user-role-module/role-module-mapping/save/${roleId}`, { modules }),
  // moduleIds: the role's assigned modules in sidebar order (see features/sidebar-order.js)
  saveOrder: (roleId, moduleIds) =>
    axiosClient.put(`/user-role-module/role-module-mapping/save-order/${roleId}`, { module_ids: moduleIds }),
};

export default apiRoleModuleMapping;
